module.exports = __webpack_public_path__ + "static/media/uniswap.209612d8.svg";